module.exports = __webpack_public_path__ + "media/images/modal-close-9508fe04bb25764c435f9feba2f87e8a.svg";